import { createRouter, createWebHistory } from 'vue-router'
import DeviceList from '../views/DeviceList.vue'
import WifiConfig from '../views/WifiConfig.vue'

const routes = [
  {
    path: '/',
    name: 'DeviceList',
    component: DeviceList
  },
  {
    path: '/wifi-config',
    name: 'WifiConfig',
    component: WifiConfig
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 